/* eslint-disable @faire/no-re-exports */ export { TestimonialCarousel } from "@faire/retailer-visitor-shared/components/TestimonialCarousel/TestimonialCarousel";
